import i18n, { TFunction } from 'i18next'
import * as Yup from 'yup'
import { DATE_FORMAT, DATE_SEPARATOR } from '../../../config'
import { formatDate } from '../utils'
import { ARTICLE, CUSTOM_VALIDATION_ERRORS } from '../../../models/enums'

const regExText = /^[^\s][\sa-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšßẞ.'-]*$/

const getValidationSchema = (storefrontData, t: TFunction) => {
  const storefrontMinAge = storefrontData?.vehicleData?.minAge
  const minAllowedAge = storefrontMinAge > 18 ? storefrontMinAge : 18

  return Yup.object().shape({
    additionalDrivers: Yup.array().of(
      Yup.object()
        .shape({
          firstName: Yup.string()
            .matches(regExText, CUSTOM_VALIDATION_ERRORS.valueInvalid(t('additional-drivers:firstName'), ARTICLE.EINEN))
            .min(2, i18n.t('validation:minLength', { value: 2 }))
            .max(35, i18n.t('validation:maxLength', { value: 35 }))
            .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('additional-drivers:firstName'), ARTICLE.EINEN)),
          lastName: Yup.string()
            .matches(regExText, CUSTOM_VALIDATION_ERRORS.valueInvalid(t('additional-drivers:lastName'), ARTICLE.EINEN))
            .min(2, i18n.t('validation:minLength', { value: 2 }))
            .max(35, i18n.t('validation:maxLength', { value: 35 }))
            .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('additional-drivers:lastName'), ARTICLE.EINEN)),
          dateOfBirth: Yup.string()
            .formatOfDate(
              DATE_FORMAT,
              DATE_SEPARATOR,
              CUSTOM_VALIDATION_ERRORS.valueInvalid(t('additional-drivers:dateOfBirth'), ARTICLE.EIN)
            )
            .notInFuture(DATE_SEPARATOR, i18n.t('validation:dateInFuture'))
            .notMoreThanHundredYearsAgo(
              DATE_SEPARATOR,
              i18n.t('validation:dateMoreThanHundredYearsAgo')
            )
            .fullAge(
              minAllowedAge,
              DATE_SEPARATOR,
              i18n.t('validation:minAge', {
                minAge: minAllowedAge,
              })
            )
            .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('additional-drivers:dateOfBirth'), ARTICLE.EIN)),
        })
        .test(
          'matches-main-driver',
          i18n.t('validation:driverIsMainDriver'),
          value => {
            const prohibitedDriver = {
              firstName: storefrontData?.customerData?.firstName,
              lastName: storefrontData?.customerData?.lastName,
              dateOfBirth: formatDate(
                storefrontData?.customerData?.dateOfBirth
              ),
            }
            return (
              value.firstName !== prohibitedDriver.firstName ||
              value.lastName !== prohibitedDriver.lastName ||
              value.dateOfBirth !== prohibitedDriver.dateOfBirth
            )
          }
        )
    ),
  })
}

export default getValidationSchema
